import { isInvalidPatientIdRoute } from '~/utils/isUuid'

// Guard against navigations built with a missing patient id (e.g. `/patients/${undefined}/...`).
// Without this the page still mounts and every store queries `id=eq.undefined` → Postgres 22P02
// "invalid input syntax for type uuid: undefined" — a whole class of prod Sentry noise
// (HEALDESK-1J/1K/1M/1N/1P/1Q/1R) AND a broken screen for the user. Redirect to the patient
// list BEFORE any DB call. Routes without an `:id` (list/create/intake) are left untouched.
export default defineNuxtRouteMiddleware((to) => {
  if (isInvalidPatientIdRoute(to.path, to.params.id)) {
    return navigateTo('/patients')
  }
})
